/* eslint-disable react-hooks/exhaustive-deps */
import React,{FC, useEffect, useState} from "react";
import { Dropdown, FormControl, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import useAxiosPrivate from "../../../../libs/useAxiosPrivate";
import { getCommodityList } from "../core/_requests";
import {FixedSizeList as List} from 'react-window'

type CommodityDropdownProps = {
  onSelect: (hs:any) => void;
  selectedHS?: string;
}

type selectedCommodityType = {
  hs:string
  description:string
  display:string
}


const CommodityDropdown:FC<CommodityDropdownProps> = ({
  onSelect, selectedHS
}) => {
  const axiosPrivate = useAxiosPrivate()
  const [commodities, setCommodities] = useState<Array<any> | null>([])
  const [searchTerm, setSearchTerm] = useState<string>(''); 
  const [selectedCommodity, setSelectedCommodity] = useState<selectedCommodityType>(); 
  const [filteredCommodity, setFilteredCommodity] = useState<Array<any>>([]);
  const [isLoading, setIsLoading] = useState(true)

  useEffect(()=>{
    setIsLoading(true)
    getCommodityList(axiosPrivate)
      .then(res=>{
        const listDropdown = res.data.hs_list.map(data=>{
          return {
            ...data,
            display:`${data.hs} - ${data.description.toLowerCase()}`
          }
        })
        setCommodities(listDropdown)
        setFilteredCommodity(listDropdown)
        if(selectedHS){
          const hsData = listDropdown.find(data=>data.hs===selectedHS)
          setSelectedCommodity(hsData)
          onSelect(hsData);
        }
      })
      .catch(e=>{
        console.error(e)
      })
      .finally(()=>{
        setIsLoading(false)
      })
  },[])

  useEffect(()=>{
    setFilteredCommodity(filteredCommodity!)
  },[filteredCommodity])

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => { 
    const value = event.target.value; 
    setSearchTerm(value); 
    
    const filteredList = commodities?.filter(data=>data.display.includes(value.toLowerCase()))
    setFilteredCommodity(filteredList!)
  };

  const removeSearchTerm = () =>{
    setSearchTerm(''); 
    setFilteredCommodity(commodities!)
  }
  
  const handleSelect = (selectedItem) => { 
    onSelect(selectedItem);
    setSelectedCommodity(selectedItem)
  }

  // Row Renderer for react-window 
  const Row = ({ index, style }) => {
    return (
      <OverlayTrigger 
        key={filteredCommodity[index].hs} 
        placement="right" 
        overlay={<Tooltip id={`tooltip-${filteredCommodity[index].hs}`}>{filteredCommodity[index].description}</Tooltip>} 
        > 
        <Dropdown.Item role="menuitem" size="sm" style={{
          ...style,
        }} onClick={()=>handleSelect(filteredCommodity[index])}> 
          {filteredCommodity[index].display} 
        </Dropdown.Item> 
      </OverlayTrigger>
    );
  }
  

  return (
    
    <Dropdown className="w-100" onToggle={removeSearchTerm}>
      <Dropdown.Toggle variant="label-dropdown" id="" className="btn btn-sm btn-bold dropdown-toggle fw-normal text-start w-100" style={{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
      }} disabled={isLoading}>
        {isLoading 
          ? ( 
            <div style={{ display: 'flex', alignItems: 'center' }}> 
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> 
              <span style={{ marginLeft: '5px' }}>Loading the commodities...</span> 
            </div>) 
          : (selectedCommodity 
            ? ( 
              <div style={{ 
                whiteSpace: 'nowrap', 
                overflow: 'hidden', 
                textOverflow: 'clip', 
                width: '50vw' 
              }}> 
                {selectedCommodity.display} 
              </div> ) 
            : ( 'Select Commodities' ))
        }
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-commodity-menu">
        <FormControl 
          type="text" 
          size="sm"
          placeholder="Search..." 
          className="dropdown-econ-search-bar" 
          value={searchTerm} 
          onChange={handleSearch} 
          style={{}}/>
            <List
              height={300}
              itemCount={filteredCommodity.length}
              itemSize={35}
              width='100%'>
              {Row}
            </List>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default CommodityDropdown